module.exports = __webpack_public_path__ + "static/media/Ilustración para portada_Moquegua.a698f9c1.jpg";